export const HOST_NAME = "recorder-dataset.respeecher.com";
// export const HOST_NAME = "recorder.minikube.local";
export const HOST_URL = `https://${HOST_NAME}`;
export const APPLICATION_ID = "9353ff40-37dc-498c-b52d-59b981903a2f";
// export const APPLICATION_ID = "9d507dbf-6cc3-4509-b29a-a4f740bc76b8";
export const REFRESH_TOKEN = "refresh_token";
export const JWT_RETRY_TIMEOUT = 30 * 1000; // 30 sec
export const JWT_REFRESH_WINDOW_SEC = 300; // 5 min
export const CACHE_TIMEOUT = 3 * 60 * 1000; // 3 min
export const timeToStale = 5;
export const NOTIFICATION_TIMEOUT = 4000;
export const MAX_TEXT_LENGTH = 300;
export const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const recorderDefaultConfig = {
  bufferLength: 4096,
  encoderApplication: 2049,
  encoderFrameSize: 20,
  encoderPath: "/opus-recorder/encoderWorker.min.js",
  encoderSampleRate: 48000,
  encoderBitRate: 196000,
  maxFramesPerPage: 40,
  mediaTrackConstraints: {
    autoGainControl: false,
    echoCancellation: false,
    noiseSuppression: false,
    deviceId: null,
  },
  monitorGain: 0,
  numberOfChannels: 1,
  recordingGain: 1,
  resampleQuality: 3,
  streamPages: false,
  reuseWorker: false,
  wavBitDepth: 16,
};

export const recordingStatuses = {
  ALL: "all",
  NO_RECORDING: "no_recording",
  BAD: "bad",
  DONE: "done",
  QUESTIONABLE: "questionable",
  UNREVIEWED: "unreviewed",
  REDO: "redo",
  APPROVED: "approved",
};
export const projectStates = {
  OK: "ok",
  PROCESSING: "processing",
  UPLOADING: "uploading",
  ERROR: "error",
};
export const userRoles = {
  USER: "user",
  REVIEWER: "reviewer",
  ADMIN: "admin",
};
export const statusColor = (status) => {
  switch (status) {
    case recordingStatuses.DONE:
    case recordingStatuses.APPROVED:
      return "green";
    case recordingStatuses.BAD:
    case recordingStatuses.REDO:
      return "red";
    case recordingStatuses.QUESTIONABLE:
      return "orange";
    case recordingStatuses.ALL:
      return "blue";
    default:
      return "grey";
  }
};
export const statusText = (status) => {
  if (status === recordingStatuses.NO_RECORDING) {
    return "no recording";
  }
  return status;
};
